import { useCallback } from "react";
import { useFocusableContext } from "./Contexts.js";
const useKeyNavigation = ({ changeExpand, expanded, depth, isInteractive, listItemRef, onClick }) => {
  const { nextFocusable, previousFocusable } = useFocusableContext();
  return useCallback((event) => {
    if (!listItemRef.current || event.defaultPrevented) {
      return;
    }
    if (document.activeElement !== listItemRef.current) {
      if (depth > 0 && event.code === "ArrowLeft" && expanded) {
        changeExpand(false);
        listItemRef.current.focus();
        event.preventDefault();
      }
      return;
    }
    switch (event.code) {
      case "ArrowLeft":
        if (expanded) {
          changeExpand(false);
        } else {
          previousFocusable()?.focus();
        }
        event.preventDefault();
        break;
      case "ArrowRight":
        if (!expanded && isInteractive) {
          changeExpand(true);
        } else {
          nextFocusable()?.focus();
        }
        event.preventDefault();
        break;
      case "Space":
        changeExpand(!expanded);
        event.preventDefault();
        break;
      case "Enter":
        onClick(event);
        event.preventDefault();
        break;
      case "ArrowUp":
        previousFocusable()?.focus();
        event.preventDefault();
        break;
      case "ArrowDown":
        nextFocusable()?.focus();
        event.preventDefault();
        break;
    }
  }, [changeExpand, depth, expanded, isInteractive, listItemRef, nextFocusable, onClick, previousFocusable]);
};
export {
  useKeyNavigation
};
//# sourceMappingURL=useKeyNavigation.js.map
